var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import * as Styled from "./BodyStyles";
var Body = function (_a) {
    var className = _a.className, children = _a.children, size = _a.size, withoutMargins = _a.withoutMargins, _b = _a.multiline, multiline = _b === void 0 ? false : _b, weight = _a.weight, color = _a.color, props = __rest(_a, ["className", "children", "size", "withoutMargins", "multiline", "weight", "color"]);
    return (React.createElement(Styled.Body, __assign({ size: size, withoutMargins: withoutMargins, multiline: multiline, weight: weight, color: color }, props), children));
};
export default Body;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm9keS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkJvZHkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUMvQixPQUFPLEtBQUssTUFBTSxNQUFNLGNBQWMsQ0FBQztBQWF2QyxJQUFNLElBQUksR0FBRyxVQUFDLEVBU047SUFSTixJQUFBLFNBQVMsZUFBQSxFQUNULFFBQVEsY0FBQSxFQUNSLElBQUksVUFBQSxFQUNKLGNBQWMsb0JBQUEsRUFDZCxpQkFBaUIsRUFBakIsU0FBUyxtQkFBRyxLQUFLLEtBQUEsRUFDakIsTUFBTSxZQUFBLEVBQ04sS0FBSyxXQUFBLEVBQ0YsS0FBSyxjQVJJLG1GQVNiLENBRFM7SUFFUixPQUFPLENBQ0wsb0JBQUMsTUFBTSxDQUFDLElBQUksYUFDVixJQUFJLEVBQUUsSUFBSSxFQUNWLGNBQWMsRUFBRSxjQUFjLEVBQzlCLFNBQVMsRUFBRSxTQUFTLEVBQ3BCLE1BQU0sRUFBRSxNQUFNLEVBQ2QsS0FBSyxFQUFFLEtBQUssSUFDUixLQUFLLEdBRVIsUUFBUSxDQUNHLENBQ2YsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGVBQWUsSUFBSSxDQUFDIn0=